import { Component, OnInit } from '@angular/core';

import {Router} from '@angular/router';
import {RestapiService} from '../restapi.service';

@Component({
  selector: 'app-analyst-help',
  templateUrl: './analyst-help.component.html',
  styleUrls: ['./analyst-help.component.css']
})
export class AnalystHelpComponent implements OnInit {

  constructor(private router: Router, private _rest: RestapiService) { }
  respObject: any;
  respvObject: any;
  fileData: any;
  hasData=false;
  downLoadPath=this._rest.FILE_PATH;
  
  docTitle=""
  ngOnInit(): void {
  	const req = {}
      this._rest.getHelpDoc(req).subscribe((res) => {
        this.respvObject = res;
        console.log(res);
        if(this.respvObject.error==0){
        	this.fileData = this.respvObject.resp;
        } else {
        	this.hasData=false;
        }

      });
  }
}

